export const BLOCK_TYPES = {
    genericText: 'genericText',
    descriptiveText: 'descriptiveText'
};

export const COMPONENT_TYPES = {
    textBlocks: 'textBlocks',
    availabilityCalendar: 'availabilityCalendar',
    pricingGrid: 'pricingGrid',
    visualItinerary: 'visualItinerary',
    stepBlock: 'stepBlock',
    deckPlan: 'deckPlan',
    packageCardBlocks: 'packageCardBlocks',
    tutorial: 'tutorial',
    sharedTable: 'shared-table'
};
